import React from "react";
import styled from "styled-components";
import { ContentWrapper } from "../pages/InsuranceGuidance";
import TopBanner from "../components/TopBanner";

const OurTeam = () => {
  return (
    <>
      <TopBanner content={"Our Team"} />
      <ContentWrapper>
        <Content>
          <h1>
            The People Behind <span>Wealthies</span>
          </h1>

          <p>
            At Wealthies, our team is focused on simplifying insurance awareness
            and helping individuals better understand insurance-related
            processes.
          </p>

          <p>
            We bring together professionals across different functions to ensure
            that users receive clear information, structured guidance, and
            seamless platform support.
          </p>

          <h2>A Structured Team Focused on Clarity and Support</h2>

          <p>
            Wealthies operates through a coordinated team structure designed to
            improve user experience, simplify insurance understanding, and
            facilitate connections with licensed insurance professionals.
          </p>

          <p>
            Each team plays a defined role in helping individuals navigate
            insurance-related decisions with greater clarity and confidence.
          </p>

          <h2>Wealth Management Team</h2>
          <h5>Insurance Awareness & Guidance</h5>
          <p>
            The Wealth Management Team focuses on helping individuals understand
            insurance concepts, coverage structures, and key factors to consider
            while exploring financial protection options.
          </p>
          <p>
            The team works to simplify complex insurance topics into clear,
            easy-to-understand information to support informed decision-making.
          </p>
          <p>
            Includes professionals with relevant domain knowledge, including
            members holding valid IRDAI certifications where applicable.
          </p>

          <h2>Advisor Relationship Team</h2>
          <h5>Advisor Network & Onboarding</h5>
          <p>
            The Advisor Relationship Team works closely with licensed insurance
            professionals associated with the platform.
          </p>
          <p>
            In addition to managing advisor relationships, the team is
            responsible for onboarding insurance professionals onto the
            Wealthies platform, ensuring structured processes and smooth
            integration.
          </p>
          <p>
            They help maintain coordination and enable effective communication
            between users and advisors.
          </p>

          <h2>Customer Support Team</h2>
          <h5>User & Advisor Assistance</h5>
          <p>
            The Customer Support Team assists both individuals and advisors with
            platform-related queries, communication support, and coordination.
          </p>
          <p>
            The team ensures that users receive timely responses and that
            advisors are supported in managing inquiries and interactions
            efficiently.
          </p>

          <h2>Operations & Billing Team</h2>
          <h5>Platform & Process Management</h5>
          <p>
            The Operations & Billing Team manages backend operations including
            invoicing, payment coordination, and administrative processes
            related to platform services.
          </p>
          <p>
            This team ensures that all operational workflows are handled
            efficiently and transparently.
          </p>

          <h2>Wealthies Shield Team</h2>
          <h5>Guidance & Support Assistance</h5>
          <p>
            The Wealthies Shield Team supports individuals in understanding
            insurance-related processes such as claims, renewals, and
            documentation requirements.
          </p>
          <p>
            The team focuses on providing structured guidance to help users
            navigate policy-related situations with greater clarity.
          </p>
          <p>
            Includes members with relevant experience, including IRDAI-certified
            professionals where applicable, who assist in explaining general
            processes related to claims and renewals.
          </p>

          <h2>Supported by a Licensed Advisor Network</h2>
          <p>
            Wealthies is supported by a network of licensed insurance
            professionals who assist individuals with insurance-related queries
            and help explain policy features when required.
          </p>

          <h2>Our Approach</h2>
          <ul>
            <li>Simplifying insurance awareness</li>
            <li>Clear and structured communication</li>
            <li>User-focused support</li>
            <li>Transparent platform experience</li>
          </ul>

          <p>
            <strong>Built for Clarity. Designed for Confidence.</strong>
          </p>
          <p>
            At Wealthies, every team works toward a common goal — making
            insurance easier to understand and helping individuals navigate
            their insurance journey with greater confidence.
          </p>
        </Content>
      </ContentWrapper>
    </>
  );
};

export default OurTeam;

const Content = styled.div`
  h1 {
    font-size: 2.5rem;
    color: #005f73;
  }

  h2 {
    margin-top: 30px;
    color: #005f73;
  }

  h5 {
    margin-top: 10px;
    color: #003366;
  }

  span {
    color: #fdc500;
  }

  p {
    font-size: 1.1rem;
    line-height: 1.7;
    color: #333;
  }

  ul {
    margin-top: 10px;
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
    font-size: 1.05rem;
    color: #333;
  }
`;
